<div class="full-height">
  <ssa-side-menu>
    <ssa-app-bar></ssa-app-bar>
    <router-outlet></router-outlet>
  </ssa-side-menu>
</div>

